module.exports = __webpack_public_path__ + "img/y-96.df2a7536.png";